import React, {useContext} from "react"

import LogoTop from "../LogoTop";
import TranslationContext from "../../../context/TranslationContext";
import BuilderContext from "../../../context/BuilderContext"


const WelcomeMessage = () => {
    const {getTranslation} = useContext(TranslationContext)
    const {style} = useContext(BuilderContext)
    const defaultWelcomeMessage = "Бесплатная<br>Wi-Fi зона"
    // debugger
    // console.log(getTranslation("free_mess"))
    if (style.welcome_mess.trim() === defaultWelcomeMessage ) {
        return (<>
            <span>{getTranslation("free_mess")}</span>
            <br/>
            <span className="nowrap" >{getTranslation("wz_mess")}</span>
        </>)
    }
    const spl = style.welcome_mess.split("<br>")
    if (spl.length > 1) {
        return (<span>
            {spl.map((x, i) => <><span key={i}>{x}</span><br/></> )}
        </span>)
    }
    return (<span>{style.welcome_mess}</span>)
}

const Header = () => {
    const {getTranslation} = useContext(TranslationContext)
    const {style} = useContext(BuilderContext)

    return (
        <div id="header" className="segment-border">
            <h1
                className="welcome-mess"
                data-idphrase="free"
                id="welcome_title"
            >
                <WelcomeMessage />
            </h1>
            {
                style.welcome_img !== "" && (
                    <LogoTop
                        link={style.welcome_img}
                        position={"welcome"}
                    />
                )
            }
        </div>
    )
}

export default Header